import { 
  authService as sharedAuthService
} from '@watchlist/shared';

// Re-export the shared auth service for backward compatibility
export const authService = sharedAuthService; 